import { gql } from '@apollo/client'

export const RESET_PASSWORD = gql`
  mutation resetPassword($password: String!, $passwordToken: String!) {
    resetPassword(password: $password, passwordToken: $passwordToken) {
      success
    }
  }
`
